module.exports = __webpack_public_path__ + "static/media/hackathon.3fa86d0b.jpg";